import React, { useState, useEffect } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { EntityRefLink, catalogApiRef } from "@backstage/plugin-catalog-react";
import { Table, TableColumn } from "@backstage/core-components";
import { Entity } from '@backstage/catalog-model';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';

import { pagesTranslationRef} from '../../translations/pages';
import AreaPage from './page';


const ServicesTable = () => {
    const pageSize = 10;
    const [items, setItems] = useState<Entity[] | null>(null);
    const catalogApi = useApi(catalogApiRef);
    const {t} = useTranslationRef(pagesTranslationRef);
    const columns: TableColumn[] = [{
        title: t('pages.service'),
        highlight: true,
        render: (data: any, _): any => {
            return <EntityRefLink entityRef={data} />;
        },
    }];
    useEffect(() => {
        (async () => {
            const items = await catalogApi.getEntities({
                filter: [
                    { kind: 'Component' },
                    { 'metadata.type': 'Service' },
                ]
            });
            setItems(items.items.sort((a, b) => (
                (a?.metadata?.title || '').localeCompare(b?.metadata?.title || '', undefined, {numeric: true}))
            ));
        })();
    }, [catalogApi]);

    return (
        <Table
            title={t('pages.services')}
            options={{
                padding: "dense",
                paging: true,
                search: false,
                sorting: false,
                pageSize: pageSize,
            }}
            isLoading={items === null ? true : undefined}
            columns={columns}
            data={items || []}
        />
    );
}


export const ServicesPage = () => <AreaPage titleKey="pages.services" area="areaServices" side={<ServicesTable />} />;
